// Meta Pixel da LP Sofia (Manu Imóveis — BM Gabriel Senna Consultor).
// Isolado nesta LP: o fbq só é injetado quando initSofiaPixel() roda (no mount da SofiaLP),
// pra não poluir as outras landing pages do projeto.
//
// Funil de 2 eventos (SPEC 70):
//   - Lead      → preencheu o formulário (passo 1: nome+telefone+email)
//   - Schedule  → agendou (passo 3 confirmado) = resultado principal da campanha

export const SOFIA_PIXEL_ID = '3663262750494852';

let injected = false;

// Carrega o snippet base do Meta Pixel uma única vez e dispara o PageView.
export function initSofiaPixel() {
  if (typeof window === 'undefined') return;
  if (injected) {
    // já carregado neste SPA — só conta a visualização da página
    window.fbq?.('track', 'PageView');
    return;
  }
  injected = true;

  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq('init', SOFIA_PIXEL_ID);
  window.fbq('track', 'PageView');
}

// Dispara um evento padrão do pixel. eventId é compartilhado com a Conversions API
// server-side pra o Meta deduplicar o evento do navegador com o do servidor.
function track(eventName, { eventId, ...params } = {}) {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq(
    'track',
    eventName,
    { content_name: 'Sofia Campo Belo', ...params },
    eventId ? { eventID: eventId } : undefined,
  );
}

// Lead = preencheu o formulário (passo 1). "Já é lead", mesmo sem agendar.
export function trackSofiaLead(opts = {}) {
  track('Lead', opts);
}

// Schedule = agendou (passo 3 confirmado). Resultado principal da campanha.
export function trackSofiaSchedule(opts = {}) {
  track('Schedule', opts);
}
